import { useCallback, useState } from 'react';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { AnnouncementTypeEnum } from 'src/infrastructure/rest-api/api-types';
import { useApiMutation } from 'src/infrastructure/rest-api/useApi';

interface Props {
    title: string;
    description: string;
    type: AnnouncementTypeEnum;
}

export const useCreateNewAnnouncement = ({ title, description, type }: Props) => {
    const [createAnnouncement] = useApiMutation('/api/announcements', 'post', {
        update(data, _variables, queryClient) {
            queryClient.setQueryData(['/api/announcements'], data);
        },
    });

    const [isUpdating, setIsUpdating] = useState(false);

    const showSnackbar = useChangesSnackbar();

    const creatingAnnouncement = useCallback(async () => {
        setIsUpdating(true);

        const payload = {
            title,
            description,
            announcementTypeEnum: type,
            moduleEnum: null,
        };
        try {
            const response = await createAnnouncement({
                body: payload,
            });
            showSnackbar(undefined, {
                showCubeTimer: false,
                successMessage: `Announcement '${title}' has been created!`,
            });
            return response;
        } catch (err) {
            showSnackbar(err);
        } finally {
            setIsUpdating(false);
        }
    }, [createAnnouncement, title, description, type, showSnackbar]);

    return [creatingAnnouncement, { loading: isUpdating }] as const;
};
